module.exports = __webpack_public_path__ + "img/luonnonmuistomerkki_original.9bb85ed5.jpg";